/**
 * Created by slava on 13/3/19
 */

Match3SceneComponent.prototype.addScoreView = function () {

};

ComingSoonLocationView.prototype.addBackground = function () {

};